export default __webpack_public_path__ + "static/media/greenTriangle.6edc6bdd.svg";